import React from 'react'
import './LoadingSpinner.css'

const LoadingSpinner = ({ 
  size = 'medium', 
  color = 'primary', 
  text = 'Loading...', 
  overlay = false,
  className = '' 
}) => {
  const sizeClasses = {
    small: 'spinner-small',
    medium: 'spinner-medium', 
    large: 'spinner-large'
  }

  const colorClasses = {
    primary: 'spinner-primary',
    secondary: 'spinner-secondary',
    white: 'spinner-white'
  }

  const spinnerElement = (
    <div className={`loading-spinner ${sizeClasses[size]} ${colorClasses[color]} ${className}`}>
      <div className="spinner-border" role="status">
        <span className="sr-only">{text}</span>
      </div>
      {text && <div className="spinner-text">{text}</div>}
    </div>
  )

  if (overlay) {
    return (
      <div className="loading-overlay">
        {spinnerElement}
      </div>
    )
  }

  return spinnerElement
}

export default LoadingSpinner
